import styled from 'styled-components';
import { Table } from 'antd';

export const TabelaDetalhes = styled(Table)`
  .linha-alterada > td {
    background-color: #fff7e6 !important;
    font-weight: 600;
  }
`;

export const GrupoFilho = styled.div`
  margin-bottom: 20px;

  .ant-table-wrapper {
    margin-top: 8px;
  }
`;
